import { LitElement, html, css } from 'lit'
import { property, customElement } from 'lit/decorators.js'
import { booleanAttributeSchema } from './helpers/yup'
import type { StackItemAttributes } from 'zaptic-stack-item'

const convertGrowAttributeToSchema = (value: unknown) => {
    try {
        return booleanAttributeSchema.validateSync(value)
    } catch (ignore) {
        return null
    }
}

@customElement('zaptic-stack-item')
export class StackItem extends LitElement implements StackItemAttributes {
    static styles = css`
        :host {
            flex-shrink: 0;
            display: block;
        }

        :host([grow]) {
            flex-grow: 1;
        }
    `

    @property({
        reflect: true,
        type: Boolean,
        converter: convertGrowAttributeToSchema,
    })
    grow = false

    render() {
        return html`<slot></slot>`
    }
}
